'use client';

import { useEffect, useState } from 'react';
import { useFirstInteraction } from '@/contexts/FirstInteractionContext';

export function AOSProvider({ children }: { children: React.ReactNode }) {
  const hasInteracted = useFirstInteraction();
  const [aosLoaded, setAosLoaded] = useState(false);

  useEffect(() => {
    // Only load AOS after user interaction
    if (!hasInteracted || aosLoaded) return;

    // Dynamically import AOS after interaction
    import('aos').then(({ default: AOS }) => {
      // Dynamically load AOS CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/aos@3.0.0-beta.6/dist/aos.css';
      document.head.appendChild(link);

      // Initialize AOS after CSS is loaded
      link.onload = () => {
        AOS.init({
          duration: 700,
          once: true, // Animations trigger only once - reduces reflows after first scroll
          easing: 'ease',
          delay: 0,
          offset: 200,
          // Performance optimizations to reduce forced reflows
          throttleDelay: 99, // Throttle scroll calculations (default: 99ms)
          debounceDelay: 50, // Debounce resize calculations (default: 50ms)
          disableMutationObserver: false, // Keep watching for DOM changes
        });
        setAosLoaded(true);
      };
    });
  }, [hasInteracted, aosLoaded]);

  return <>{children}</>;
} 